export const quickFacts = [
  { value: '4 条', label: '官方下载渠道' },
  { value: '24h', label: '入口持续监测' },
  { value: 'v4.2', label: '当前安装包版本' },
  { value: '免安装', label: '支持网页在线看' },
];

export const updateFeed = [
  {
    id: 'u1',
    date: '10-10',
    tag: '入口变更',
    title: '官网主入口完成线路切换',
    desc: '主域名解析已指向新节点，访问速度与稳定性同步提升。',
  },
  {
    id: 'u2',
    date: '10-06',
    tag: '域名更新',
    title: '发布最新地址公告',
    desc: '旧地址进入只读状态，请以本页展示的入口为准。',
  },
  {
    id: 'u3',
    date: '09-28',
    tag: '版本更新',
    title: 'APP 安装包 v4.2 上线',
    desc: '优化播放内核与缓存策略，安装包体积进一步压缩。',
  },
  {
    id: 'u4',
    date: '09-20',
    tag: '线路优化',
    title: '在线看线路新增两条',
    desc: '新增备用线路，弱网环境下可手动切换。',
  },
  {
    id: 'u5',
    date: '09-12',
    tag: '入口变更',
    title: '扫码入口支持多端识别',
    desc: '同一张二维码可按设备自动跳转对应下载页。',
  },
  {
    id: 'u6',
    date: '09-03',
    tag: '安全公告',
    title: '谨防仿冒安装包',
    desc: '官方安装包仅通过本页渠道提供，请勿下载来源不明的文件。',
  },
];

export const downloadChannels = [
  {
    id: 'd1',
    name: '官网直链下载',
    platform: 'Windows / macOS',
    size: '约 68 MB',
    method: '点击即下',
    tag: '推荐',
    icon: 'ri-computer-line',
    note: '适合桌面端，安装后可在设置内自动检查更新。',
    highlight: true,
  },
  {
    id: 'd2',
    name: '扫码下载安装包',
    platform: 'Android / iOS',
    size: '约 54 MB',
    method: '扫码获取',
    tag: '移动端',
    icon: 'ri-qr-code-line',
    note: '使用系统相机扫描，按提示完成安装即可。',
    highlight: false,
  },
  {
    id: 'd3',
    name: '镜像安装包',
    platform: 'Android',
    size: '约 52 MB',
    method: '镜像站获取',
    tag: '备用',
    icon: 'ri-download-cloud-2-line',
    note: '主渠道拥堵时使用，内容与官方一致。',
    highlight: false,
  },
  {
    id: 'd4',
    name: '网页在线看',
    platform: '全平台',
    size: '无需安装',
    method: '直接打开',
    tag: '免下载',
    icon: 'ri-play-circle-line',
    note: '无需安装包，打开最新地址即可开始浏览。',
    highlight: false,
  },
];

export const guideSteps = [
  {
    step: '01',
    title: '打开最新地址',
    desc: '使用本页展示的官方入口，进入网页端起始页。',
    icon: 'ri-link',
  },
  {
    step: '02',
    title: '选择可用线路',
    desc: '在起始页选择延迟较低的线路，弱网环境可切换备用线路。',
    icon: 'ri-route-line',
  },
  {
    step: '03',
    title: '开始浏览内容',
    desc: '进入合集页后按分类或更新顺序查看，播放页支持清晰度切换。',
    icon: 'ri-play-list-2-line',
  },
  {
    step: '04',
    title: '收藏以便回访',
    desc: '将当前最新地址加入书签，避免下次重新查找入口。',
    icon: 'ri-bookmark-3-line',
  },
];

export const packageSpecs = [
  { label: '当前版本', value: 'v4.2.0', icon: 'ri-price-tag-3-line' },
  { label: '安装包体积', value: '54 MB', icon: 'ri-hard-drive-3-line' },
  { label: '兼容系统', value: 'Android 8.0+ / iOS 14+ / Win10+ / macOS 12+', icon: 'ri-device-line' },
  { label: '更新方式', value: '应用内自动检测更新', icon: 'ri-refresh-line' },
  { label: '文件校验', value: '支持 MD5 校验，安装前可比对', icon: 'ri-shield-check-line' },
  { label: '语言支持', value: '简体中文', icon: 'ri-translate-2' },
];

export const guideArticles = [
  {
    id: 'g1',
    category: '新手指南',
    title: '第一次使用？从入口到浏览的完整路径',
    excerpt: '梳理官方入口、安装包与在线看的先后顺序，帮助首次接触的用户快速上手。',
    readTime: '4 分钟',
    icon: 'ri-compass-3-line',
  },
  {
    id: 'g2',
    category: '入口答疑',
    title: '最新地址为何会变化，如何确认是官方',
    excerpt: '说明地址更新的常见原因，以及几处可以互相印证的官方标识。',
    readTime: '3 分钟',
    icon: 'ri-question-answer-line',
  },
  {
    id: 'g3',
    category: '下载说明',
    title: '安装包与网页端的取舍对照',
    excerpt: '对比安装包与在线看两种方式的占用、更新与体验差异。',
    readTime: '5 分钟',
    icon: 'ri-scales-3-line',
  },
  {
    id: 'g4',
    category: '使用技巧',
    title: '弱网环境下的线路选择方法',
    excerpt: '通过延迟测试与备用线路切换，改善浏览时的加载表现。',
    readTime: '3 分钟',
    icon: 'ri-signal-wifi-line',
  },
  {
    id: 'g5',
    category: '安全提醒',
    title: '识别仿冒安装包的几个细节',
    excerpt: '从来源、校验值与安装提示三方面判断安装包是否可信。',
    readTime: '4 分钟',
    icon: 'ri-shield-star-line',
  },
  {
    id: 'g6',
    category: '内容浏览',
    title: '合集页的浏览顺序与收藏方式',
    excerpt: '介绍合集页的排序逻辑与收藏、回访的便捷做法。',
    readTime: '3 分钟',
    icon: 'ri-bookmark-2-line',
  },
];

export const faqs = [
  {
    q: '小蓝视频官网入口在哪里可以找到？',
    a: '本页展示的入口即为官方渠道，按页面提示进入即可；如遇无法打开，可切换备用入口或稍后重试。',
  },
  {
    q: '小蓝视频 APP 下载方式有哪些？',
    a: '提供官网直链、扫码下载与镜像安装包三种方式，移动端优先使用扫码下载，桌面端使用直链下载。',
  },
  {
    q: '小蓝视频最新地址为什么会变动？',
    a: '地址会因线路调整而更新，本页信息栏会同步公告最新变化，建议收藏本页方便再次进入。',
  },
  {
    q: '安装包需要付费或登录吗？',
    a: '安装包获取与网页浏览均为免费，页面上的按钮仅作展示，不涉及登录或支付流程。',
  },
  {
    q: '可以不安装直接在线看吗？',
    a: '可以，网页在线看通道无需安装包，打开最新地址后选择线路即可开始浏览。',
  },
];

export const entryChannels = [
  {
    id: 'e1',
    name: '官网主入口',
    status: '可用',
    latency: '延迟 32ms',
    desc: '主域名解析入口，连接稳定，日常访问优先使用。',
    icon: 'ri-global-line',
    primary: true,
  },
  {
    id: 'e2',
    name: '备用入口',
    status: '可用',
    latency: '延迟 45ms',
    desc: '主入口拥堵或无法打开时的替代通道。',
    icon: 'ri-route-line',
    primary: false,
  },
  {
    id: 'e3',
    name: '移动端入口',
    status: '可用',
    latency: '延迟 38ms',
    desc: '针对手机流量网络优化，适合移动端直接打开。',
    icon: 'ri-smartphone-line',
    primary: false,
  },
];

export const navLinks = [
  { id: 'n1', label: '官网入口', href: '#entry' },
  { id: 'n2', label: 'APP 下载', href: '#download' },
  { id: 'n3', label: '最新地址', href: '#updates' },
  { id: 'n4', label: '在线看', href: '#online' },
  { id: 'n5', label: '常见疑问', href: '#faq' },
];

export const tickerItems = [
  '最新地址已更新 · 10 月 10 日',
  '主入口完成线路切换，访问更稳定',
  'APP 安装包 v4.2 已上线',
  '在线看新增两条备用线路',
  '官方渠道仅本页展示，谨防仿冒',
];